/*
  Harbour Europe – EU localisation (EU visitors only).

  For visitors flagged as European (<html class="eu-visitor"> / 'harbour:eu-visitor-detected', both set by
  assets/geoip.js from GeoIP continent EU, the EU site cookie, ?region=eu or ?force_region=eu) this:
    1. Converts measurements to metric: inches / feet / mm → cm, lb → kg, yards → m, sq ft → m², miles → km,
       and drops the US fabric counts ("over 70 performance / luxury / premium outdoor fabrics" → "performance /
       luxury / premium outdoor fabrics", "70+ fabrics" → "fabrics").
    2. Hides prices (with assets/eu-region.css, which hides the theme's price elements).
    3. Writes dates day-first: "October 6, 2026" / "10/06/2026" → "6 October 2026".
    4. Uses European English: aluminium, colour, centre, metre, catalogue, customise, programme,
       and swaps US seasonal copy (Thanksgiving, holiday season).
  1 and 2 apply in every language; 3 and 4 only while the page is in English (Weglot handles the others).
  US visitors never run any of this, so the theme content itself stays US.

  Only visible text is touched (text nodes plus alt / title / placeholder / aria-label), never URLs,
  handles, classes, CSS or data attributes. To exclude an element, add data-eu-spelling-skip to it.
  Loaded from snippets/geoip-eu-welcome-popup.liquid (every storefront page) and snippets/hp-print-head.liquid
  (tear sheet and lookbook, where it runs for the EU version only: ?region=eu or the EU site cookie).
*/
(function () {
  if (window.HarbourEuSpelling) return;

  /* ---------- 1. Measurements (all languages) ---------- */

  var NUM = '(\\d{1,3}(?:,\\d{3})+(?:\\.\\d+)?|\\d+(?:\\.\\d+)?)';
  function num(s) { return parseFloat(String(s).replace(/,/g, '')); }
  function fmt(n, dp) { return String(parseFloat(n.toFixed(dp))); }
  function cmFromIn(n) { return fmt(n * 2.54, 0); }
  function spaceIfLetter(str, end) { return /[A-Za-z]/.test(str.charAt(end) || '') ? ' ' : ''; }

  var UNIT_RULES = [
    // Tear sheet header
    [/\bmm \/ kg\b/g, 'cm / kg'],
    // Square feet → m²
    [new RegExp(NUM + '[-\\s](?:square|sq\\.?)[-\\s]?(?:feet|foot|ft)\\b', 'gi'), function (m, n) { return fmt(num(n) * 0.092903, 0) + ' m²'; }],
    // Feet + inches, e.g. 7'6"
    [new RegExp('(\\d+)\\s?(?:′|\'|’)\\s?' + NUM + '\\s?(?:″|"|”)', 'g'), function (m, ft, inch) { return cmFromIn(num(ft) * 12 + num(inch)) + ' cm'; }],
    // Dimension lists with one trailing unit, e.g. 96 x 33.5 x 35.4 in / 2438 × 850 × 900 mm
    [new RegExp('(' + NUM + '(?:\\s?[x×]\\s?' + NUM + ')+)\\s?(mm|inches|inch|in\\.?|″|")(?![A-Za-z])', 'gi'), function (m, list) {
      var unit = arguments[arguments.length - 3].toLowerCase();
      var parts = list.split(/\s?[x×]\s?/i);
      var out = [];
      for (var i = 0; i < parts.length; i++) out.push(unit === 'mm' ? fmt(num(parts[i]) / 10, 1) : cmFromIn(num(parts[i])));
      return out.join(' × ') + ' cm';
    }],
    // Inches, e.g. 96" / 96″W / 84 inches
    [new RegExp(NUM + '(?:″|"|”|\\s(?:″|inches|inch)\\b|\\s?inches\\b)', 'g'), function (m, n, off, str) { return cmFromIn(num(n)) + ' cm' + spaceIfLetter(str, off + m.length); }],
    // Feet, e.g. 9' / 10 ft / 9-foot (not 1990's)
    [new RegExp(NUM + '(?:(?:′|\'|’)(?![sS\\d])|\\s?ft\\b\\.?|[-\\s]f(?:oo|ee)t\\b)', 'g'), function (m, n, off, str) { return fmt(num(n) * 30.48, 0) + ' cm' + spaceIfLetter(str, off + m.length); }],
    // Yards → m
    [new RegExp(NUM + '\\s?(?:yards?|yds?)\\b', 'gi'), function (m, n) { return fmt(num(n) * 0.9144, 1) + ' m'; }],
    // Pounds → kg
    [new RegExp(NUM + '\\s?(?:lbs?|pounds?)\\b', 'gi'), function (m, n) { return fmt(num(n) * 0.45359237, 1) + ' kg'; }],
    // Miles → km
    [new RegExp(NUM + '\\s?(?:miles?|mi\\.)(?=[\\s,.;)]|$)', 'gi'), function (m, n) { return fmt(num(n) * 1.609344, 0) + ' km'; }],
    // Millimetres → cm
    [new RegExp(NUM + '\\s?mm\\b', 'g'), function (m, n) { return fmt(num(n) / 10, 1) + ' cm'; }],
    // "43 cm / 43.2 cm" (converted inches next to exact metric) → keep the exact metric value
    [/\b\d+(?:\.\d+)? cm\s?\/\s?(\d+(?:\.\d+)? cm)/g, '$1'],
    [/\b\d+(?:\.\d+)? kg\s?\/\s?(\d+(?:\.\d+)? kg)/g, '$1'],
    // Price note on printed documents
    [/Prices are MSRP in USD as of [^.]*?subject to change\.\s*/g, '']
  ];
  var UNIT_TEST = /\d\s?(?:″|"|”|′|'|’|-?f(?:oo|ee)?t|inch|in\.|mm|lb|pound|yard|yd|mi|square|sq)|[x×]\s?\d|mm \/ kg|Prices are MSRP/i;

  // EU copy: the European range has fewer fabrics, so drop the "70" fabric counts.
  //   "over 70 luxury fabrics" → "luxury fabrics", "70+ fabrics" → "fabrics" (case follows the original).
  function startsSentence(str, off) { var before = str.slice(0, off); return /^\s*$/.test(before) || /[.!?:]\s*$/.test(before); }
  function fabricCase(m, word, off, str) {
    if (m === m.toUpperCase()) return word.toUpperCase();
    return (/^[A-Z]/.test(m) || startsSentence(str, off)) ? word.charAt(0).toUpperCase() + word.slice(1) : word;
  }
  var COPY_RULES = [
    // "over 70 performance / luxury / premium outdoor fabrics" → "performance / luxury / premium outdoor fabrics"
    [/\bover 70 ([a-z]+)(?=(?: [a-z]+){0,2} fabrics\b)/gi, function (m, w, off, str) { return fabricCase(m, w.toLowerCase(), off, str); }],
    [/(^|[^\w])70\+ fabrics\b/gi, function (m, pre, off, str) { return pre + fabricCase(m.slice(pre.length), 'fabrics', off + pre.length, str); }]
  ];
  var COPY_TEST = /over 70 [a-z]|70\+ fabrics/i;

  function convertUniversal(text) {
    if (text && COPY_TEST.test(text)) {
      for (var cr = 0; cr < COPY_RULES.length; cr++) text = text.replace(COPY_RULES[cr][0], COPY_RULES[cr][1]);
    }
    if (!text || !UNIT_TEST.test(text)) return text;
    var out = text;
    for (var i = 0; i < UNIT_RULES.length; i++) out = out.replace(UNIT_RULES[i][0], UNIT_RULES[i][1]);
    return out;
  }

  /* ---------- 2. European English and day-first dates (English only) ---------- */

  // Exact copy swaps (applied first, case-sensitive).
  var PHRASES = [
    // Homepage dining feature
    ['In stock · Ready for Thanksgiving', 'In stock'],
    // Fall dining page
    ['SET THE TABLE FOR THANKSGIVING', 'SET THE TABLE FOR THE FESTIVE SEASON'],
    ['With Thanksgiving approaching', 'With the festive season approaching'],
    ['in time for the holidays', 'in time for Christmas'],
    // In-stock living page
    ['HOME FOR THE HOLIDAYS', 'HOME FOR CHRISTMAS'],
    ['in style for the Holidays', 'in style this festive season'],
    ['ensuring your space is holiday-ready', 'ensuring your space is ready for Christmas']
  ];

  // Proper nouns that must keep their US spelling (e.g. US venue names).
  var PROTECTED = ['Decorative Center', 'Dec Center', 'Design Center', 'Market Center', 'Rockefeller Center'];

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var M = '(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sept|Sep|Oct|Nov|Dec)\\.?';
  function day(d) { return String(parseInt(d, 10)); }

  // Spelling and date rules. Case is preserved for spelling (aluminum → aluminium, ALUMINUM → ALUMINIUM).
  var WORDS = [
    [/\s*·\s*Ready for Thanksgiving\b/gi, ''],
    [/\bReady for Thanksgiving\b/gi, ''],
    [/\bholiday season\b/gi, 'festive season'],
    [/\baluminum\b/gi, 'aluminium'],
    [/\bcustomiz(e|es|ed|ing|ation|ations|able)\b/gi, function (m, s) { return 'customis' + s; }],
    [/\bprogram(s?)\b/gi, function (m, s) { return 'programme' + (s ? 's' : ''); }],
    [/\bcolor(s|ed|ful|ing|way|ways)?\b/gi, function (m, s) { return 'colour' + (s || ''); }],
    [/\bcenter(s|ed|ing)?\b/gi, function (m, s) { return { '': 'centre', s: 'centres', ed: 'centred', ing: 'centring' }[(s || '').toLowerCase()]; }],
    [/\b(centi|milli|kilo)?meter(s?)\b/gi, function (m, p, s) { return (p || '') + 'metre' + (s ? 's' : ''); }],
    [/\bcatalog(s?)\b/gi, function (m, s) { return 'catalogue' + (s ? 's' : ''); }]
  ];
  var DATES = [
    // October 6, 2026 / Oct. 6th 2026 / OCTOBER 06, 2026 → 6 October 2026
    [new RegExp('\\b' + M + '\\s+(\\d{1,2})(?:st|nd|rd|th)?,?\\s+(\\d{4})\\b', 'gi'), function (m, mon, d, y) { return day(d) + ' ' + mon + ' ' + y; }],
    // October 12–14 (2026) → 12–14 October (2026)
    [new RegExp('\\b' + M + '\\s+(\\d{1,2})\\s?([–-])\\s?(\\d{1,2})(?:,?\\s+(\\d{4}))?\\b', 'gi'), function (m, mon, a, dash, b, y) { return day(a) + dash + day(b) + ' ' + mon + (y ? ' ' + y : ''); }],
    // October 6 / Oct 6th → 6 October (capitalised month only, so "may 2" is left alone)
    [new RegExp('\\b' + M + '\\s+(\\d{1,2})(?:st|nd|rd|th)?\\b(?![\\d:,/])', 'g'), function (m, mon, d) { return day(d) + ' ' + mon; }],
    // 10/06/2026 (US month/day) → 6 October 2026
    [/\b(\d{1,2})\/(\d{1,2})\/(\d{4})\b/g, function (m, a, b, y) {
      var mo = parseInt(a, 10), d = parseInt(b, 10);
      return mo >= 1 && mo <= 12 && d >= 1 && d <= 31 ? d + ' ' + MONTHS[mo - 1] + ' ' + y : m;
    }]
  ];
  var LANG_TEST = /thanksgiving|holiday|aluminum|customiz|program|color|center|meter|catalog|\d\/\d|(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?\s+\d/i;

  function matchCase(original, replacement) {
    if (!replacement) return replacement;
    if (original === original.toUpperCase() && original !== original.toLowerCase()) return replacement.toUpperCase();
    var first = original.charAt(0);
    if (first === first.toUpperCase() && first !== first.toLowerCase()) {
      return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }
    return replacement;
  }

  function convertLang(text) {
    if (!text || !LANG_TEST.test(text)) return text;
    var out = text;
    for (var i = 0; i < PHRASES.length; i++) {
      if (out.indexOf(PHRASES[i][0]) !== -1) out = out.split(PHRASES[i][0]).join(PHRASES[i][1]);
    }
    var held = [];
    for (var p = 0; p < PROTECTED.length; p++) {
      if (out.indexOf(PROTECTED[p]) !== -1) {
        out = out.split(PROTECTED[p]).join('\u0000' + held.length + '\u0000');
        held.push(PROTECTED[p]);
      }
    }
    for (var w = 0; w < WORDS.length; w++) {
      var rule = WORDS[w];
      out = out.replace(rule[0], function (m) {
        var r = typeof rule[1] === 'function' ? rule[1].apply(null, arguments) : rule[1];
        return matchCase(m, r);
      });
    }
    for (var h = 0; h < held.length; h++) out = out.split('\u0000' + h + '\u0000').join(held[h]);
    for (var d = 0; d < DATES.length; d++) out = out.replace(DATES[d][0], DATES[d][1]);
    return out;
  }

  /* ---------- 3. Prices (all languages) ---------- */

  var PRICE = /(?:US\$|\$|€|£)\s?\d[\d,]*(?:\.\d{1,2})?(?:\s?(?:USD|EUR|GBP))?|\b\d[\d,]*(?:\.\d{2})?\s?(?:USD|EUR)\b/;
  var PRICE_G = new RegExp(PRICE.source, 'g');
  var PRICE_WORDS = /\b(?:MSRP|RRP|from|trade|price|sale|was|now|regular|starting at|each|ea|USD|EUR)\b|[\s\-–—•·|\/:()]/gi;
  function isPriceOnly(t) { return !!t && PRICE.test(t) && t.replace(PRICE_G, '').replace(PRICE_WORDS, '') === ''; }
  function hide(el) { el.style.setProperty('display', 'none', 'important'); el.setAttribute('data-eu-price-hidden', ''); }

  function hidePrice(node) {
    var t = node.nodeValue;
    if (!t || !PRICE.test(t)) return;
    var el = node.parentNode;
    if (!el || el.nodeType !== 1) return;
    if (isPriceOnly(t)) {
      // Hide the smallest wrapper that only holds price text (e.g. "From $2,400").
      var target = el, depth = 0;
      while (depth < 4 && target.parentNode && target.parentNode.nodeType === 1 && target.parentNode !== document.body &&
             !/^(TD|TH|LI|BUTTON|OPTION|FORM|SECTION|ARTICLE|MAIN|BODY)$/.test(target.parentNode.nodeName) &&
             isPriceOnly(target.parentNode.textContent)) { target = target.parentNode; depth++; }
      if (/^(OPTION|TD|TH|BUTTON)$/.test(target.nodeName)) node.nodeValue = '';
      else hide(target);
    } else if (/^(OPTION|BUTTON|LABEL)$/.test(el.nodeName) || /price/i.test(el.className || '')) {
      // Mixed text in controls, e.g. "Charcoal / Teak - $1,234" → "Charcoal / Teak"
      node.nodeValue = t.replace(new RegExp('\\s*[-–—•·|:]?\\s*(?:From\\s+)?(?:' + PRICE.source + ')', 'g'), '');
    }
  }

  /* ---------- Applying it to the page ---------- */

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1, IFRAME: 1 };
  var ATTRS = ['alt', 'title', 'placeholder', 'aria-label'];
  var SHADOW_HOSTS = '#fast-simon-serp-app, #serp-portal, .fast-ac-container, .mobile-fast-ac-container';
  var english = true;

  function convert(text) {
    var out = convertUniversal(text);
    return english ? convertLang(out) : out;
  }

  // Remember what we changed so the English-only part can be undone if the visitor switches language.
  var changed = [];

  function isSkipped(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) {
      if (SKIP_TAGS[n.nodeName] || n.isContentEditable || (n.hasAttribute && n.hasAttribute('data-eu-spelling-skip'))) return true;
    }
    return false;
  }

  function fixText(node) {
    if (isSkipped(node.parentNode)) return;
    var before = node.nodeValue;
    var after = convert(before);
    if (after !== before) {
      node.nodeValue = after;
      changed.push({ node: node, orig: before, eu: after });
    }
    hidePrice(node);
  }

  function fixAttrs(el) {
    if (isSkipped(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (v) {
        var nv = convert(v);
        if (nv !== v) { el.setAttribute(ATTRS[i], nv); changed.push({ node: el, attr: ATTRS[i], orig: v, eu: nv }); }
      }
    }
    if (el.nodeName === 'INPUT' && /^(submit|button)$/i.test(el.type) && el.value) {
      var bv = convert(el.value);
      if (bv !== el.value) { changed.push({ node: el, attr: 'value', orig: el.value, eu: bv }); el.value = bv; }
    }
  }

  // Specs band on product pages (sections/pdp-tearsheet.liquid): EU shows metric only, so drop the
  // secondary imperial figure (now converted to a duplicate cm/kg value).
  function tidy(root) {
    if (!root.querySelectorAll) return;
    var subs = root.querySelectorAll('.pdp-ts__eu > span');
    for (var i = 0; i < subs.length; i++) {
      if (/^\s*[\d.,]+\s?(?:cm|kg|mm|″|"|lb)\s*$/.test(subs[i].textContent)) hide(subs[i]);
    }
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType === 1 && SKIP_TAGS[root.nodeName]) return;
    if (root.nodeType === 1) fixAttrs(root);
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null, false);
    var n;
    while ((n = tw.nextNode())) {
      if (n.nodeType === 3) fixText(n);
      else fixAttrs(n);
    }
    tidy(root);
  }

  function currentLang() {
    try {
      if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') return window.Weglot.getCurrentLang() || '';
    } catch (e) {}
    var m = window.location.hash.match(/weglot-([a-z]{2})/i);
    if (m) return m[1];
    return document.documentElement.getAttribute('lang') || 'en';
  }

  function revertLang() {
    // Undo the English-only changes on nodes still showing our text; anything Weglot has since translated is left alone.
    for (var i = changed.length - 1; i >= 0; i--) {
      var c = changed[i], back = convertUniversal(c.orig);
      if (c.attr) {
        if (c.attr === 'value') { if (c.node.value === c.eu) c.node.value = back; }
        else if (c.node.getAttribute(c.attr) === c.eu) c.node.setAttribute(c.attr, back);
      } else if (c.node.nodeValue === c.eu) {
        c.node.nodeValue = back;
      }
    }
    changed = [];
  }

  // Watch for content rendered after load (cart drawer, quick view, variant changes, Fast Simon results, etc.).
  var pending = [];
  var timer = null;
  var active = false;
  function flush() {
    timer = null;
    var batch = pending; pending = [];
    if (!active) return;
    for (var i = 0; i < batch.length; i++) walk(batch[i]);
    attachShadowRoots();
  }
  function onMutations(list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m.type === 'childList') { for (var j = 0; j < m.addedNodes.length; j++) pending.push(m.addedNodes[j]); }
      else pending.push(m.target);
    }
    if (pending.length && !timer) timer = setTimeout(flush, 30);
  }
  function observe(root) {
    new MutationObserver(onMutations).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  var seenShadow = [];
  function attachShadowRoots() {
    var hosts = document.querySelectorAll(SHADOW_HOSTS);
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (sr && seenShadow.indexOf(sr) === -1) { seenShadow.push(sr); walk(sr); observe(sr); }
    }
  }

  function start() {
    if (active) return;
    active = true;
    english = /^en/i.test(currentLang());
    walk(document.body);
    attachShadowRoots();
    observe(document.body);
  }

  function bindWeglot() {
    if (!window.Weglot || typeof window.Weglot.on !== 'function') return false;
    window.Weglot.on('languageChanged', function (lang) {
      english = /^en/i.test(lang || '');
      if (!active) return;
      if (english) { walk(document.body); attachShadowRoots(); }
      else revertLang();
    });
    return true;
  }

  window.HarbourEuSpelling = {
    convert: convert,
    // Convert a root (document, element or <template> content) once.
    apply: function (root) { walk(root || document.body); }
  };

  /* ---------- Printable documents (tear sheet ?view=tearsheet, lookbook ?view=lookbook) ---------- */

  var isPrint = !!window.HARBOUR_TS_REGION || /[?&]view=(?:tearsheet|lookbook)\b/.test(window.location.search);
  if (isPrint) {
    var region = window.HARBOUR_TS_REGION;
    if (!region) {
      var r = (window.location.search.match(/[?&]region=(eu|us)\b/) || [])[1];
      var c = (document.cookie.match(/(?:^|; )harbour_eu_acknowledged=([^;]*)/) || [])[1];
      region = r === 'eu' || (r !== 'us' && c === 'eu') ? 'eu' : 'us';
    }
    if (region === 'eu') {
      var convertSheet = function () {
        var css = document.createElement('style');
        css.textContent = '.hp-price, tr.hp-price { display: none !important; }';
        document.head.appendChild(css);
        // Lookbook "W × D × H" cells list inches then exact mm underneath: keep just the metric line.
        var cells = document.querySelectorAll('.lb-card .hp-specs td');
        for (var i = 0; i < cells.length; i++) {
          var span = cells[i].querySelector('span');
          if (span && /mm\s*$/.test(span.textContent)) cells[i].textContent = span.textContent;
        }
        walk(document.documentElement);
        var ts = document.querySelectorAll('template');
        for (var t = 0; t < ts.length; t++) if (ts[t].content) walk(ts[t].content);
      };
      // Loaded with defer, so the page is already parsed: convert before the print tools build the PDF pages.
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', convertSheet);
      else convertSheet();
    }
    return;
  }

  function init() {
    if (document.documentElement.classList.contains('eu-visitor')) start();
    document.addEventListener('harbour:eu-visitor-detected', start);
    var tries = 0;
    (function retry() { if (!bindWeglot() && tries++ < 20) setTimeout(retry, 300); })();
  }
  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
